import './assets';

import 'core-js/fn/object/assign';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/keys';
import 'core-js/fn/string/repeat';

import * as deepmerge from 'deepmerge';
import * as angular from 'angular';
import 'angular-sanitize';
// import 'ui-bootstrap4';
import ngRedux from 'ng-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { ThunkDispatch } from 'redux-thunk';
import { Reducer } from 'redux';
import '../../../../node_modules/custom-components/dist';

import reducers from '../reducers';

import {
  OLIGO_MODAL_SUPPORT_NAME,
  OLIGO_MODAL_SUPPORT_SERVICE_NAME,
  OligoModalSupportController,
  OligoModalSupportPanel,
  OligoModalSupportService,
  OligoModalTypes,
} from '../components/oligo-modal-support/oligo-modal-support';

import {
  PROJECT_IMPORT_MODAL_NAME,
  ProjectImportModal,
  ProjectImportModalController,
  ProjectImportModalSupport,
  ProjectImportState,
  ProjectImportStates,
} from '../components/project-import-modal/project-import-modal';

import { OLIGO_CONFIG_DETAIL_NAME, OligoConfigDetail, OligoConfigDetailController } from '../components/oligo-config-detail/oligo-config-detail';
import { PROJECT_DETAIL_NAME, ProjectDetail } from '../components/project-detail/project-detail';
import { PROJECT_HEADER_NAME, ProjectHeader, ProjectHeaderController } from '../components/project-detail/project-header/project-header';
import { PROJECT_FOOTER_NAME, ProjectFooter, ProjectFooterController } from '../components/project-detail/project-footer/project-footer';
import { PROJECT_PREFERENCE_NAME, ProjectPreference, ProjectPreferenceController } from '../components/project-detail/project-preference/project-preference';
import { OLIGO_SUMMARY_BAR_NAME, OligoSummaryBar, OligoSummaryBarController } from '../components/oligo-summary-bar/oligo-summary-bar';
import { OLIGO_SUMMARY_BAR_MANAGER_NAME, OligoSummaryBarManager } from '../components/oligo-summary-bar-manager/oligo-summary-bar-manager';
import { OLIGO_CONFIG_PREFERENCE_NAME, OligoConfigPreference, OligoConfigPreferenceController } from '../components/oligo-config-preference/oligo-config-preference';
import { DRAG_AND_DROP_NAME, DragAndDropCreator } from '../components/drag-and-drop/drag-and-drop';
import { FANCY_MESSAGE_PANE_NAME, FancyMessagePaneCreator } from '../components/fancy-message-pane/fancy-message-pane';

import { APP_CONFIG_SERVICE_NAME, AppConfigService, AppConfigServiceFactory, PathConfig, UriConfig } from '../service/app-config-service';
import { PROJECT_SERVICE_NAME, ProjectServiceFactory } from '../service/project-service';
import { CALCULATION_SERVICE_NAME, CalculationServiceFactory } from '../service/calculation-service';
import { asUserContext, USER_DETAILS__SERVICE_NAME, UserDetails, UserDetailsService, UserDetailsServiceFactory } from '../service/user-details-service';
import { PRICING_SERVICE_NAME, PricingServiceFactory } from '../service/pricing-service';
import { CART_SERVICE_NAME, CartServiceFactory } from '../service/cart-service';
import { ANALYTICS_SERVICE_NAME, AnalyticsService, AnalyticsServiceFactory } from '../service/analytics-service';
import { SESSION_SERVICE_NAME, SessionService, SessionServiceFactory } from '../service/session-service';
import { ALERT_SERVICE_NAME, AlertService, AlertServiceFactory } from '../service/alert-service';
import { PROJECT_ACTIONS_SERVICE_NAME, ProjectActions, ProjectActionsService, ProjectAdd, ProjectAddFnRequest, ProjectAddSupport } from '../actions/project-actions';
import { OLIGO_ACTIONS_SERVICE_NAME, OligoActionsService } from '../actions/oligo-actions';
import { WORLD_ACTIONS_SERVICE_NAME, WorldActions, WorldActionsService, WorldDataUpdate, WorldDataUpdateFnRequest, WorldDataUpdateSupport } from '../actions/world-actions';
import { ROOT_ACTIONS_SERVICE_NAME, RootActions, RootActionsService, RootDataLoad, RootDataLoadFnRequest, RootDataLoadSupport } from '../actions/root-actions';

import * as Model from '../models';
import * as I18n from '../models/i18n';

import { storageMiddleware } from '../service/storage-service';
import { countOligos } from '../models/util';
import { CARD_DETAIL_NAME, CardDetail, CardDetailController } from '../components/card-detail/card-detail';
const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const HTTP_RESET_CONTENT = 205;

const enableStackableModals = () => {
  try {
    const bsJQ: Model.BootstrapJQ = $.fn as Model.BootstrapJQ;
    if (bsJQ.modal && bsJQ.modal.Constructor) {
      const version: string = bsJQ.modal.Constructor.VERSION;
      // Bootstrap 2 has no version indicator
      if (!version) {
        // for bootstrap 2, monkeypatch the function so that
        // stackable modals work
        const isBS2: boolean = bsJQ.modal.toString().indexOf('bs.modal') === -1;
        if (isBS2) {
          bsJQ.modal.Constructor.prototype.enforceFocus = () => {
            /* Prevent stack size exception: https://github.com/twbs/bootstrap/pull/5022*/
          };
        }
      }
    }
  } catch (e) {
    console.error(e);
  }
};

const bindPageVisibility = (document: Document, callback: (hidden: boolean) => void): void => {
  const pageVisibilityKeys = {
    hidden: 'visibilitychange',
    webkitHidden: 'webkitvisibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
  };
  let pageVisibilityEventKey: string | undefined;
  let pageVisibilityStateKey: string | undefined;
  for (pageVisibilityStateKey in pageVisibilityKeys) {
    if (pageVisibilityStateKey in document) {
      pageVisibilityEventKey = pageVisibilityKeys[pageVisibilityStateKey];
      break;
    }
  }
  if (pageVisibilityEventKey && pageVisibilityStateKey) {
    document.addEventListener(pageVisibilityEventKey, () => callback(document[pageVisibilityStateKey as string]), false);
  }
};

const doLogout = (logoutUrl: string, logoutDelay: number, onLogout: () => void): void => {
  console.error('User has questionable identity. Logging out...');
  const logoutFrame: HTMLIFrameElement = document.createElement('iframe');
  logoutFrame.id = 'loggout-frame';
  logoutFrame.style.display = 'none';
  logoutFrame.style.width = '0';
  logoutFrame.style.height = '0';
  document.body.appendChild(logoutFrame);
  logoutFrame.addEventListener('load', () => {
    setTimeout(() => {
      document.body.removeChild(logoutFrame);
      onLogout();
    }, logoutDelay);
  });
  logoutFrame.src = logoutUrl;
};

const timeNow = (): number => {
  try {
    return Date.now();
  } catch (e) {
    return new Date().getTime();
  }
};

const logger: any = createLogger({
  collapsed: true,
  level: 'info',
  predicate: (getState, action) => process.env.ENV !== 'prod',
});

const _DEPENDENCIES: string[] = [
  // 'ui.bootstrap',
  'custom-components',
  'ngSanitize',
  ngRedux,
];

configure.$inject = [
  '$logProvider',
  '$compileProvider',
  '$locationProvider',
  '$ngReduxProvider',
];
function configure($logProvider: ng.ILogProvider,
                   $compileProvider: ng.ICompileProvider,
                   $locationProvider: ng.ILocationProvider,
                   $ngReduxProvider: ngRedux.INgReduxProvider): void {
  $logProvider.debugEnabled(true);
  $compileProvider.debugInfoEnabled(true);
  $locationProvider.html5Mode(false);
  const storageKey: string = Model.STORAGE_KEY_PRFIX;
  const storageType: string = Model.STORAGE_TYPE;
  const sessionStorageMiddleware: ngRedux.Middleware = storageMiddleware({
    key: storageKey,
    type: storageType,
  });
  const middlewares: ngRedux.Middleware[] = [thunk, sessionStorageMiddleware, logger];
  $ngReduxProvider.createStoreWith(reducers as Reducer<Model.RootState>, middlewares);
}

type ProjectsAware = {
  projects: Model.ProjectItem[];
  reachedMaxNoOfOligos: boolean;
  tombstoneStart: number;
  language?: string;
};

type I18nAware = {
  HEADER_TITLE: string;
  HEADER_DESC: string;
  HEADER_DESC_TPL: string;
  BULK_UPLOAD_LABEL: string;
  ADD_PROJECT_LABEL: string;
  DATA_LOADING_TEXT: string;
  CONFIG_SCROLL_TO_VIEW_TEXT: string;
  MAX_OLIGO_REACHED_HINT: string;
  NOTIFICATION_HEADER_MSG_LABEL: string;
  SESSION_EXPIRED_MSG_LABEL: string;
  SIGN_IN_OK_LABEL_MSG: string;
  UNABLE_TO_FULFIL_REQUEST_MSG_LABEL: string;
};

class AppController implements ng.IController, I18nAware, ProjectAddSupport, ProjectsAware, WorldDataUpdateSupport, RootDataLoadSupport {

  public static NAME: string = 'AppController';
  public static UNEXPECTED_EXCEPTION?: object | null;

  public loading: boolean = true;

  public projects: Model.ProjectItem[] = [];
  public reachedMaxNoOfOligos: boolean = false;
  public addProject: ProjectAdd | null = null;
  public updateWorldData: WorldDataUpdate | null = null;
  public loadStorageData: RootDataLoad | null = null;
  public userAgent: string = '';
  public tombstoneStart: number = 10;
  public projectImportModalSupport: ProjectImportModalSupport;
  /**
   * The value for this will get bound on build time
   */
  public config: PathConfig = {
    path: '',
    name: '',
    hash: '',
  };

  public HEADER_TITLE: string = 'Custom Standard DNA Oligos';
  public HEADER_DESC: string = `Use the Custom Standard DNA Oligo Tool below to add your oligo sequences or benefit from our Bulk Upload option to import up to 200 oligo sequences at one time.`;
  public HEADER_DESC_TPL: string = '';
  public BULK_UPLOAD_LABEL: string = 'Bulk Upload';
  public ADD_PROJECT_LABEL: string = 'Add Another Project';
  public DATA_LOADING_TEXT: string = 'We are processing your request. This may take a moment. Please wait...';
  public CONFIG_SCROLL_TO_VIEW_TEXT: string = 'Scroll to view';
  public MAX_OLIGO_REACHED_HINT: string = `You have reached or exceeded the maximum limit of {{${I18n.PlaceHolderKeys.MAX_OLIGO_COUNT}}} oligos.`;
  public $postLink: () => void;
  public uriConfig?: UriConfig;
  public language?: string;
  public NOTIFICATION_HEADER_MSG_LABEL: string = 'Notification';
  public SESSION_EXPIRED_MSG_LABEL: string = 'Your session may have expired. You may need to sign in again to your account.';
  public SIGN_IN_OK_LABEL_MSG: string = 'Sign In';
  public UNABLE_TO_FULFIL_REQUEST_MSG_LABEL: string = 'There was an issue fulfilling your request. We apologize for the inconvenience. Please try again.';

  constructor($scope: ng.IScope,
              $window: ng.IWindowService,
              $element: ng.IRootElementService,
              $http: ng.IHttpService,
              $ngRedux: ngRedux.INgRedux,
              projectActions: ProjectActions,
              worldActions: WorldActions,
              rootActions: RootActions,
              oligoModelSupportService: OligoModalSupportService,
              configService: AppConfigService,
              analyticsService: AnalyticsService,
              userDetailService: UserDetailsService,
              sessionService: SessionService,
              alertService: AlertService) {
    const bindDispatchers = (dispatch: ThunkDispatch<Model.RootState, object, Model.ReduxAction<object>>) => {
      this.addProject = (request: ProjectAddFnRequest) => {
        return dispatch(projectActions.addProject(request));
      };
      this.updateWorldData = (request: WorldDataUpdateFnRequest) => {
        return dispatch(worldActions.updateWorldData(request));
      };
      this.loadStorageData = (request: RootDataLoadFnRequest) => {
        return dispatch(rootActions.loadStorageData(request));
      };
    };
    const unsubscribe = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
    let unwatchOligoThreshold: (() => void) | undefined;
    let addProjectBtnHintJQ: Model.BootstrapJQ | null;
    let unwatchUnexpectedException: () => void = () => { /* will get implemented on post link */ };
    const $postLink = (): void => {
      this.loading = true;
      configService.load(this.config).then((uriConfig: UriConfig) => {
        this.uriConfig = uriConfig;
        configService.setUriConfig(uriConfig);
        userDetailService.getUserDetails().then((userDetails: UserDetails) => {
          const { headers } = $http.defaults;
          if (headers && headers.common) {
            const userContext = asUserContext(userDetails);
            userContext.userAgent = $window.navigator.userAgent;
            headers.common.usercontext = JSON.stringify(userContext);
          }
          const { countryCode, customerType, langCode, sessionToken } = userDetails;
          if (!this.loadStorageData) {
            return;
          }
          this.loadStorageData({ countryCode, langCode, customerType, sessionToken }).then((storageData: Model.RootState) => {
            const countryPathConfig: PathConfig = {
              path: this.config.path,
              name: `${countryCode.toLowerCase()}.json`,
              hash: this.config.hash,
            };
            configService.load(countryPathConfig).then((countryConfig: UriConfig) => {
              uriConfig = deepmerge(uriConfig, countryConfig);
              this.uriConfig = uriConfig;
              configService.setUriConfig(uriConfig);
            }, () => {
              console.info(`No separate config found for '${countryCode.toUpperCase()}'.`);
            }).finally(() => {
              let checkSessionValidity: boolean = true;
              let logoutOnStaleSession: boolean = true;
              let logoutIfSignedInOnStaleSession: boolean = false;
              let logoutDelayMillis: number = 5000;
              let sessionCheckOnTabActivation: boolean = true;
              let guestUserInvalid = false;
              let differentUserInvalid = false;
              let differentCountryInvalid = true;
              configService.getAppContent(langCode).then((worldData: Model.WorldData) => {
                if (!this.updateWorldData) {
                  return;
                }
                this.updateWorldData(worldData);
                try {
                  checkSessionValidity = worldData.clientConfig.checkSessionOnLanding;
                  logoutOnStaleSession = worldData.clientConfig.skipLogoutOnStaleSession !== true;
                  logoutIfSignedInOnStaleSession = worldData.clientConfig.logoutIfSignedInOnStaleSession === true;
                  sessionCheckOnTabActivation = worldData.clientConfig.skipSessionCheckOnTabActivation !== true;
                  logoutDelayMillis = worldData.clientConfig.logoutDelayMillis || logoutDelayMillis;
                  guestUserInvalid = worldData.clientConfig.guestUserInvalid || guestUserInvalid;
                  differentUserInvalid = worldData.clientConfig.differentUserInvalid || differentUserInvalid;
                  differentCountryInvalid = worldData.clientConfig.differentCountryInvalid !== false;
                } catch (e) {
                  console.error(e);
                }
              }).finally(() => {
                this.loading = false;
                if (!this.addProject) {
                  return;
                }
                if (checkSessionValidity) {
                  const userAccessStartEpoch: number = timeNow();
                  const checkSessionValid = () => {
                    return sessionService.isCurrentSessionValid({ guestUserInvalid, differentUserInvalid, differentCountryInvalid }).then((response) => {
                      const { isValid, isSignedIn, userName, revalidationStrategy } = response;
                      if (!isValid) {
                        const status: number = HTTP_UNAUTHORIZED;
                        const sessionExpiredError: ng.IHttpResponse<string> = new Error(`${status}`) as object as ng.IHttpResponse<string>;
                        sessionExpiredError.status = status;
                        const userAccessNowEpoch: number = timeNow();
                        const appUsageDurationMins: string = ((userAccessNowEpoch - userAccessStartEpoch) / (60 * 1000)).toFixed(2);
                        alertService.error(`User session for ${userName} is stale or has expired. Is signed in now: ${isSignedIn}. App duration Mins: ${appUsageDurationMins}`);
                        const forceLogoutOnAnonymous: boolean = logoutOnStaleSession && !isSignedIn;
                        const forceLogoutOnLoggedUser: boolean = logoutOnStaleSession && isSignedIn && logoutIfSignedInOnStaleSession;
                        if (forceLogoutOnAnonymous || forceLogoutOnLoggedUser) {
                          this.loading = true;
                          doLogout(uriConfig.api.logout, logoutDelayMillis, () => $scope.$apply(() => {
                            AppController.UNEXPECTED_EXCEPTION = sessionExpiredError;
                            this.loading = false;
                          }));
                        } else {
                          if (revalidationStrategy === 'RELOAD') {
                            sessionExpiredError.status = HTTP_RESET_CONTENT;
                          }
                          AppController.UNEXPECTED_EXCEPTION = sessionExpiredError;
                          this.loading = false;
                        }
                      }
                    });
                  };
                  checkSessionValid();
                  if (sessionCheckOnTabActivation) {
                    bindPageVisibility($window.document, (hidden) => {
                      if (hidden) {
                        return;
                      }
                      checkSessionValid();
                    });
                  }
                }
                const hasExistingProjects: boolean = storageData.projects && storageData.projects.length > 0;
                if (hasExistingProjects) {
                  return;
                }
                const { location } = $window;
                const { href } = location;
                const isBulkImportOnLoad: boolean = href.indexOf(uriConfig.href.standardOligo.bulk) > 0;
                // if the initial entry point is bulk upload, let's skip default project creation
                if (isBulkImportOnLoad) {
                  return;
                }
                this.loading = true;
                this.addProject({ nextIdx: 0 })
                  .finally(() => this.loading = false);
              });
            });
          }, () => this.loading = false);
        }, () => this.loading = false);

        unwatchUnexpectedException = $scope.$watch(() => AppController.UNEXPECTED_EXCEPTION, (exception?: object | null) => {
          if (!exception) {
            return;
          }
          // try and cast the error as http error
          // and check response code if available
          const error = exception as ng.IHttpResponse<object>;
          switch (error.status) {
            case HTTP_UNAUTHORIZED:
            case HTTP_FORBIDDEN:
            case HTTP_RESET_CONTENT:
              oligoModelSupportService.show({
                title: this.NOTIFICATION_HEADER_MSG_LABEL || 'Notification',
                content: this.SESSION_EXPIRED_MSG_LABEL || `Your session may have expired. You may need to sign in again to your account.`,
                okLabel: this.SIGN_IN_OK_LABEL_MSG || 'Sign In',
                type: OligoModalTypes.INFO,
              }).finally(() => {
                this.loading = true;
                AppController.UNEXPECTED_EXCEPTION = null;
                const { location } = $window;
                const { href: currentURL } = location;
                if (error.status === HTTP_RESET_CONTENT) {
                  location.reload(); // reload only
                } else {
                  location.href = `${uriConfig.api.login}${currentURL}`; // login and redirect
                }
              });
              break;
            default:
              oligoModelSupportService.show({
                title: this.NOTIFICATION_HEADER_MSG_LABEL || 'Notification',
                content: this.UNABLE_TO_FULFIL_REQUEST_MSG_LABEL || 'There was an issue fulfilling your request. We apologize for the inconvenience. Please try again.',
                type: OligoModalTypes.INFO,
              }).finally(() => {
                this.loading = false;
                AppController.UNEXPECTED_EXCEPTION = null;
              });
              break;
          }
        });

      }, () => this.loading = false);
      analyticsService.bootstrap($scope);

      unwatchOligoThreshold = $scope.$watch(() => this.reachedMaxNoOfOligos, (reachedThreshold: boolean) => {
        if (!addProjectBtnHintJQ) {
          const addProjectHintPopover: Model.BootstrapJQ = $element.find('.app-footer .btn.btn-outline-primary') as Model.BootstrapJQ;
          if (typeof addProjectHintPopover.popover === 'function') {
            addProjectBtnHintJQ = addProjectHintPopover;
          }
        }
        if (addProjectBtnHintJQ) {
          if (reachedThreshold) {
            const { MAX_OLIGO_REACHED_HINT: content } = this;
            const popover: Model.BootstrapPopoverOptions = {
              content,
              html: true,
              placement: 'top',
              trigger: 'hover',
            };
            addProjectBtnHintJQ.popover(popover);
          } else {
            addProjectBtnHintJQ.popover('destroy');
          }
        }
      });
    };
    const unwatchScopeErrors = $scope.$on(Model.ScopeEvents.ERROR, (event: ng.IAngularEvent, errorCause: object) => {
      AppController.UNEXPECTED_EXCEPTION = errorCause;
    });

    $scope.$on('$destroy', () => {
      unsubscribe();
      unwatchScopeErrors();
      unwatchUnexpectedException();
      AppController.UNEXPECTED_EXCEPTION = null;
      if (unwatchOligoThreshold) {
        unwatchOligoThreshold();
      }
      if (addProjectBtnHintJQ) {
        addProjectBtnHintJQ.popover('destroy');
        addProjectBtnHintJQ = null;
      }
    });

    this.userAgent = $window.navigator.userAgent;
    this.projectImportModalSupport = new ProjectImportModalSupport();
    this.$postLink = $postLink;

    // reset the scroll bar on every page load
    $window.scrollTo(0, 0);
  }

  public doAddProject(): void {
    if (!this.addProject) {
      return;
    }
    if (this.cannotAddNewProject()) {
      return;
    }
    this.loading = true;
    this.addProject({ nextIdx: this.projects.length })
      .finally(() => this.loading = false);
  }

  public onCartStateChange(change: { state: Model.CartState }): void {
    const { state } = change;
    switch (state) {
      case Model.CartStates.PROCESSING:
        this.loading = true;
        break;
      default:
        this.loading = false;
        break;
    }
  }

  public showProjectImportModal(): void {
    this.projectImportModalSupport.open();
  }

  public onImportStateChange(change: { state: ProjectImportState }): void {
    const { state } = change;
    switch (state) {
      case ProjectImportStates.PROCESSING:
        this.loading = true;
        break;
      default:
        this.loading = false;
        break;
    }
  }

  public cannotAddNewProject(): boolean {
    return this.loading || this.reachedMaxNoOfOligos;
  }

  private mapStateToThis = (state: Model.RootState): ProjectsAware & I18nAware => {
    const { projects, world } = state;
    const { vocabulary, maxNoOfOligos, language, clientConfig } = world;
    const { tombstoneStart } = clientConfig;
    const HEADER_DESC_TPL = vocabulary[I18n.DictionaryKeys.APP_HEADER_DESC] || this.HEADER_DESC_TPL;
    const HEADER_DESC =  HEADER_DESC_TPL || this.HEADER_DESC ;
    // Removed code for linking of urls in the header description , since it is
    // not required for the current implementation
    // Please note removing linking of urls in the header description since there will
    // be no links in the header description and also i18n key APP_HEADER_DESC needs to be updated
    const totalNoOfOligos: number = countOligos(projects);
    const reachedMaxNoOfOligos: boolean = totalNoOfOligos >= maxNoOfOligos;
    let maxOligoReachedHint: string = vocabulary[I18n.DictionaryKeys.APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT] || this.MAX_OLIGO_REACHED_HINT;
    maxOligoReachedHint = I18n.replacePlaceHolders(maxOligoReachedHint, { [I18n.PlaceHolderKeys.MAX_OLIGO_COUNT] : `${maxNoOfOligos}` });
    return {
      projects,
      reachedMaxNoOfOligos,
      language,
      tombstoneStart,
      HEADER_DESC,
      HEADER_DESC_TPL,
      HEADER_TITLE: vocabulary[I18n.DictionaryKeys.APP_HEADER_TITLE] || this.HEADER_TITLE,
      BULK_UPLOAD_LABEL: vocabulary[I18n.DictionaryKeys.APP_HEADER_BULK_UPLOAD_BUTTON] || this.BULK_UPLOAD_LABEL,
      ADD_PROJECT_LABEL: vocabulary[I18n.DictionaryKeys.APP_FOOTER_ADD_PROJECT_BUTTON] || this.ADD_PROJECT_LABEL,
      DATA_LOADING_TEXT: vocabulary[I18n.DictionaryKeys.LOADING_VALIDATE_CONFIG_DESC] || this.DATA_LOADING_TEXT,
      CONFIG_SCROLL_TO_VIEW_TEXT: vocabulary[I18n.DictionaryKeys.CONFIG_SCROLL_TO_VIEW_TEXT] || this.CONFIG_SCROLL_TO_VIEW_TEXT,
      MAX_OLIGO_REACHED_HINT: maxOligoReachedHint,
      NOTIFICATION_HEADER_MSG_LABEL: vocabulary[I18n.DictionaryKeys.NOTIFICATION_HEADER] || this.NOTIFICATION_HEADER_MSG_LABEL,
      SESSION_EXPIRED_MSG_LABEL: vocabulary[I18n.DictionaryKeys.SESSION_EXPIRED_MSG] || this.SESSION_EXPIRED_MSG_LABEL,
      SIGN_IN_OK_LABEL_MSG: vocabulary[I18n.DictionaryKeys.SIGN_IN_OK_LABEL] || this.SIGN_IN_OK_LABEL_MSG,
      UNABLE_TO_FULFIL_REQUEST_MSG_LABEL: vocabulary[I18n.DictionaryKeys.UNABLE_TO_FULFIL_REQUEST_MSG] || this.UNABLE_TO_FULFIL_REQUEST_MSG_LABEL,
    };
  }
}

const GLOBAL_EXCEPTION_HANDLER_NAME: string = '$exceptionHandler';
const GlobalExceptionHandlerFactory: ($logger: ng.ILogService) => ng.IExceptionHandlerService =
  ($logger: ng.ILogService) => {
  return (exception: Error, cause?: string | undefined): void => {
    $logger.error(exception, cause);
    AppController.UNEXPECTED_EXCEPTION = exception;
  };
};

/**
 * If you're wondering why we are injecting dependencies manually,
 * well this is intentional. We do not want the magic that ngInject
 * does. We should explicitly state the dependencies so anyone
 * maintaining them knows it, and so that the names are explicitly
 * typed and declared
 */
GlobalExceptionHandlerFactory.$inject = ['$log'];
AppConfigServiceFactory.$inject = ['$q', '$http'];
UserDetailsServiceFactory.$inject = ['$q', '$http', APP_CONFIG_SERVICE_NAME];
AlertServiceFactory.$inject = ['$q', USER_DETAILS__SERVICE_NAME, APP_CONFIG_SERVICE_NAME];
CartServiceFactory.$inject = ['$q', '$http', APP_CONFIG_SERVICE_NAME, ALERT_SERVICE_NAME];
PricingServiceFactory.$inject = ['$q', '$http', APP_CONFIG_SERVICE_NAME, USER_DETAILS__SERVICE_NAME];
DragAndDropCreator.$inject = ['$q'];
OligoConfigDetail.$inject = ['$compile', '$timeout'];
ProjectDetail.$inject = ['$timeout', '$document', '$window'];
CardDetail.$inject = ['$timeout', '$document', '$window'];
CardDetailController.$inject = ['$scope', '$ngRedux'];
ProjectImportModal.$inject = ['$timeout', '$document'];
OligoConfigDetailController.$inject = ['$scope', '$q', '$timeout', '$interval', '$ngRedux',
  OLIGO_ACTIONS_SERVICE_NAME, WORLD_ACTIONS_SERVICE_NAME, CALCULATION_SERVICE_NAME, OLIGO_MODAL_SUPPORT_SERVICE_NAME];
ProjectPreferenceController.$inject = ['$scope', '$ngRedux', PROJECT_ACTIONS_SERVICE_NAME];
ProjectHeaderController.$inject = ['$scope', '$ngRedux', PROJECT_ACTIONS_SERVICE_NAME, OLIGO_MODAL_SUPPORT_SERVICE_NAME];
ProjectFooterController.$inject = ['$scope', '$ngRedux', OLIGO_ACTIONS_SERVICE_NAME];
OligoSummaryBarManager.$inject = ['$document', '$window', '$compile'];
OligoSummaryBarController.$inject = ['$scope', '$window', '$ngRedux', CART_SERVICE_NAME];
OligoModalSupportController.$inject = ['$scope', OLIGO_MODAL_SUPPORT_SERVICE_NAME];
OligoConfigPreferenceController.$inject = ['$scope', '$q', PROJECT_SERVICE_NAME];
ProjectImportModalController.$inject = ['$scope', '$timeout', '$q', '$location', '$ngRedux',
  PROJECT_ACTIONS_SERVICE_NAME, PROJECT_SERVICE_NAME, OLIGO_MODAL_SUPPORT_SERVICE_NAME];
ProjectServiceFactory.$inject = ['$q', '$http', APP_CONFIG_SERVICE_NAME];
CalculationServiceFactory.$inject = ['$q'];
OligoModalSupportService.$inject = ['$q'];
OligoActionsService.$inject = ['$q', PROJECT_SERVICE_NAME, PRICING_SERVICE_NAME];
ProjectActionsService.$inject = ['$q', PROJECT_SERVICE_NAME, PRICING_SERVICE_NAME];
WorldActionsService.$inject = ['$q'];
RootActionsService.$inject = ['$q'];
AnalyticsServiceFactory.$inject = ['$window', '$document'];
SessionServiceFactory.$inject = ['$q', USER_DETAILS__SERVICE_NAME];
AppController.$inject = ['$scope', '$window', '$element', '$http', '$ngRedux',
  PROJECT_ACTIONS_SERVICE_NAME, WORLD_ACTIONS_SERVICE_NAME, ROOT_ACTIONS_SERVICE_NAME,
  OLIGO_MODAL_SUPPORT_SERVICE_NAME, APP_CONFIG_SERVICE_NAME,
  ANALYTICS_SERVICE_NAME, USER_DETAILS__SERVICE_NAME,
  SESSION_SERVICE_NAME, ALERT_SERVICE_NAME,
];

angular.module('Application', _DEPENDENCIES)
       .config(configure)
       .service(OLIGO_MODAL_SUPPORT_SERVICE_NAME, OligoModalSupportService)
       .factory(OLIGO_ACTIONS_SERVICE_NAME, OligoActionsService)
       .factory(PROJECT_ACTIONS_SERVICE_NAME, ProjectActionsService)
       .factory(WORLD_ACTIONS_SERVICE_NAME, WorldActionsService)
       .factory(ROOT_ACTIONS_SERVICE_NAME, RootActionsService)
       .factory(PROJECT_SERVICE_NAME, ProjectServiceFactory)
       .factory(CALCULATION_SERVICE_NAME, CalculationServiceFactory)
       .factory(USER_DETAILS__SERVICE_NAME, UserDetailsServiceFactory)
       .factory(PRICING_SERVICE_NAME, PricingServiceFactory)
       .factory(CART_SERVICE_NAME, CartServiceFactory)
       .factory(APP_CONFIG_SERVICE_NAME, AppConfigServiceFactory)
       .factory(ANALYTICS_SERVICE_NAME, AnalyticsServiceFactory)
       .factory(SESSION_SERVICE_NAME, SessionServiceFactory)
       .factory(ALERT_SERVICE_NAME, AlertServiceFactory)
       .factory(GLOBAL_EXCEPTION_HANDLER_NAME, GlobalExceptionHandlerFactory)
       .directive(FANCY_MESSAGE_PANE_NAME, FancyMessagePaneCreator)
       .directive(DRAG_AND_DROP_NAME, DragAndDropCreator)
       .directive(OLIGO_CONFIG_DETAIL_NAME, OligoConfigDetail)
       .directive(OLIGO_SUMMARY_BAR_MANAGER_NAME, OligoSummaryBarManager)
       .directive(OLIGO_CONFIG_PREFERENCE_NAME, OligoConfigPreference)
       .directive(PROJECT_IMPORT_MODAL_NAME, ProjectImportModal)
       .directive(PROJECT_DETAIL_NAME, ProjectDetail)
       .directive(PROJECT_FOOTER_NAME, ProjectFooter)
       .directive(OLIGO_SUMMARY_BAR_NAME, OligoSummaryBar)
       .directive('cardDetail', CardDetail)
       .component(OLIGO_MODAL_SUPPORT_NAME, OligoModalSupportPanel)
       .component(PROJECT_HEADER_NAME, ProjectHeader)
       .component(PROJECT_PREFERENCE_NAME, ProjectPreference)
       .controller(AppController.NAME, AppController);

angular.element(document).ready(() => {
  angular.bootstrap('.app.container', ['Application']);
  enableStackableModals();
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/app/app.ts